var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "video_channel" }, [
        _c(
          "div",
          { staticClass: "vc_concent" },
          _vm._l(_vm.channelList, function (item) {
            return _c("div", { key: item.at_id, staticClass: "vc_item" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      item.at_name == "推荐"
                        ? "/marvel-list?id=" + item.at_id
                        : "/list-page?id=" + item.at_id,
                    target: "_blank",
                  },
                },
                [_vm._v(" " + _vm._s(item.at_name) + " ")]
              ),
            ])
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "video_details" }, [
        _c(
          "div",
          { staticClass: "v_player" },
          [
            _vm.playerOptions.sources[0].src
              ? _c("video-player", {
                  ref: "videoPlayer",
                  staticClass: "video-player vjs-custom-skin",
                  attrs: { playsinline: true, options: _vm.playerOptions },
                })
              : _vm._e(),
            !_vm.playerOptions.sources[0].src
              ? _c("div", { staticClass: "error_page" }, [
                  _vm._v(" " + _vm._s(_vm.loadMessage) + " "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAlbumDisplay,
                expression: "isAlbumDisplay",
              },
            ],
            staticClass: "video_album",
          },
          [
            _c("div", { staticClass: "album_bar" }, [
              _c("span", { staticClass: "album_item" }, [_vm._v("选集")]),
              _c(
                "span",
                { staticClass: "cancel", on: { click: _vm.disPlayAlbum } },
                [_vm._v("取消")]
              ),
            ]),
            _c(
              "ul",
              { staticClass: "album_num" },
              _vm._l(_vm.albumList, function (item, index) {
                return _c(
                  "li",
                  { key: item, class: item == _vm.videoId ? "active" : "" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/play-page?classify=3&id=" +
                            _vm.currentId +
                            "&video_id=" +
                            item,
                        },
                      },
                      [_vm._v(_vm._s(index + 1))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _c("div", { staticClass: "vd_right" }, [
          _vm.isAlbum
            ? _c("div", { staticClass: "vd_header" }, [
                _c("div", { staticClass: "vdh_author" }, [
                  _c("img", { attrs: { src: _vm.image } }),
                ]),
                _c(
                  "div",
                  { staticClass: "vdh_title" },
                  [
                    _c("p", [_vm._v(" " + _vm._s(_vm.name) + " ")]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = true
                          },
                        },
                      },
                      [_vm._v("关注")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "vd_title" }, [
            _c("p", [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _vm.isOriginal ? _c("button", [_vm._v("原创")]) : _vm._e(),
            ]),
          ]),
          _c("div", {
            staticClass: "vd_text",
            domProps: { innerHTML: _vm._s(_vm.description) },
          }),
          _c("div", { staticClass: "vd_play_comments" }, [
            _c("div", { staticClass: "vdc_play" }, [
              _vm._v(_vm._s(_vm.hitCount) + "次播放"),
            ]),
            _c("div", { staticClass: "vdc_comments" }, [
              _vm._v(
                " " + _vm._s(_vm.reviewCount ? _vm.reviewCount : 0) + "条评论 "
              ),
            ]),
          ]),
          _c("div", { staticClass: "vd_release" }, [
            _vm._v("发布于" + _vm._s(_vm.publishDate)),
          ]),
          _c("div", { staticClass: "vd_copyright" }, [
            _vm._v("版权归原作者所有，如有侵权，请联系我们"),
          ]),
          _vm._m(0),
        ]),
        _vm.hasRecommend
          ? _c("div", { staticClass: "recommend" }, [
              _c("div", { staticClass: "title" }, [_vm._v("相关推荐")]),
              _c(
                "ul",
                { staticClass: "content" },
                _vm._l(_vm.recommendList, function (item) {
                  return _c("li", { key: item.id }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/play-page?id=" +
                            item.id +
                            "&classify=" +
                            item.classify,
                          target: "_blank",
                        },
                      },
                      [
                        _c("div", { staticClass: "cul_img" }, [
                          _c("img", { attrs: { src: item.img_url, alt: "" } }),
                          _c("div", { staticClass: "time" }, [
                            _c("span", { staticClass: "v_pub" }, [
                              _vm._v(_vm._s(item.publish_date)),
                            ]),
                            _c("span", { staticClass: "v_dur" }, [
                              _vm._v(" " + _vm._s(item.video_duration)),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "cul_title1" }, [
                          _vm._v(" " + _vm._s(item.title) + " "),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "vd_cmt" }, [
          _c(
            "div",
            { staticClass: "comment" },
            [
              _vm.commentList.length > 0
                ? _c("div", { staticClass: "title" }, [_vm._v("评论")])
                : _vm._e(),
              _vm._l(_vm.commentList, function (item) {
                return _c("li", { key: item.id, staticClass: "item" }, [
                  _c("div", { staticClass: "item_label" }, [
                    _c("div", { staticClass: "portrait" }, [
                      _c("div", { staticClass: "p_img" }, [
                        _c("img", {
                          attrs: { src: item.member.avatar, alt: "" },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "commentator" }, [
                      _vm._v(_vm._s(item.member.nickname)),
                    ]),
                    _c("div", { staticClass: "grade" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.member.from_grade
                              ? item.member.from_grade
                              : "游客"
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "item_text" }, [
                    _vm._v(_vm._s(item.content)),
                  ]),
                  _c("div", { staticClass: "item_date" }, [
                    _vm._v(_vm._s(item.push_time)),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm.hasComment
            ? _c(
                "div",
                { staticClass: "act_footer" },
                [
                  _vm._v(" 请 "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = true
                        },
                      },
                    },
                    [_vm._v("打开")]
                  ),
                  _vm._v(" 科普中国APP发表评论或查看更多评论 "),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("download-dialog", {
        attrs: { visible: _vm.dialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "share_info" }, [
      _c("div", { staticClass: "share_sub" }, [_vm._v("分享到：")]),
      _c("div", {
        staticClass: "social-share",
        attrs: { "data-sites": "wechat, weibo, qq, qzone, douban" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }